<template>
  <div class="animated fadeIn">
    <basic-heading title="Test Package Groups" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list test package group'">
      <template #gated-content>
        <test-package-group-server-table />
      </template>
    </permission-alert-gate>
  </div>
</template>
<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import TestPackageGroupServerTable from "@/components/lab/testpackagegroup/TestPackageGroupServerTable";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

export default {
  name: "TestPackageGroupIndex",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TestPackageGroupServerTable,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-sort",
            linkto: "/testpackages/group-sort",
            text: "Sort",
            variant: "secondary",
          },
          {
            icon: "fa-shovel",
            linkto: "/testpackages",
            title: "Back to test packages page",
            variant: "info",
          },
          {
            icon: "fa-plus",
            linkto: "/testpackagegroups/add",
            title: "Add test package group",
            variant: "success",
            permission: this.checkPermission("add test package group"),
          },
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
  },
};
</script>
